import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../constant/company_constant";

const Footer = () => {
  return (
    <footer className="main-footer app-footer">
      <div className="app-footer__inner">
        <Link className="app-footer__brand" to="/">
          <span className="app-footer__brand-mark">
            <i className="fas fa-screwdriver-wrench" aria-hidden="true" />
          </span>
          <span>
            <strong>{COMPANY.name}</strong>
            <small>{COMPANY.tagline}</small>
          </span>
        </Link>
        <div className="app-footer__meta">
          <span>
            <i className="fas fa-shield-halved" aria-hidden="true" /> Secure
            service workspace
          </span>
          <span className="app-footer__copyright">
            &copy; {COMPANY.copyrightYear} {COMPANY.name}. All rights reserved.
          </span>
          <span className="app-footer__version">Version 1.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
